import { useSelector } from "react-redux"
import { SpeechTurn } from "../../../../interfaces/services"
import { RootState } from "../../../../store"
import React, { MouseEvent } from "react"
import { Typography } from "../../../../interfaces/typography"
import { SEC_TO_MS } from "../../../../cfg/const"
import { convertFromReduxSafeVisibleAccounts } from "../../../../lib/redux/store"

type SequenceTimelineProps = {
    userId?: string
    party: string
    lineHeight: number
    endTime?: number
    turns?: SpeechTurn[]
    callbackfn?: (event: MouseEvent<HTMLDivElement>) => void
    bgColor: string,
    prospectNotRecorded?: boolean
  }
  
  export function SequenceTimeline(props: SequenceTimelineProps) {
    const visibleAccounts = useSelector((state: RootState) => convertFromReduxSafeVisibleAccounts(state.visibleAccounts))
    const getName = () => {
      if (props.party === 'PROSPECT') return 'Prospect'
      else {
        if (visibleAccounts?.users && props.userId) {
          const potentialMatch = visibleAccounts.users.find((v) => v.user_id === props.userId)
          if (potentialMatch) return `Rep - ${potentialMatch.user_name}`
        }
        return 'Rep'
      }
    }
    
      return (
      <div className='flex flex-col'>
      <div className='flex flex-row items-center gap-1'>
        <Typography variant='mediumParagraph'>
            {getName()}
        </Typography>
        {props.prospectNotRecorded ? 
        <Typography variant='smallParagraph'>
          (Not recorded)
        </Typography> : null}
      </div>
    <div className='w-full' style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          height: `${props.lineHeight}px`,
          backgroundColor: '#ccc',
          cursor: props.callbackfn ? 'pointer' : 'initial',
          borderRadius: '2px',
  
      }}
      onMouseDown={props.callbackfn ? props.callbackfn : undefined}
      >
        {(props.turns ?? []).map((value: SpeechTurn) => {
          if (value.role === props.party && props.endTime) {
            const left = 100*value.start*SEC_TO_MS / props.endTime
            const width = 100*SEC_TO_MS*(value.end - value.start) / props.endTime
            const adjustedWidth = Math.min(100 - left, width)
            return (
              <div
              style={{
                'position': 'absolute',
                'left': `${left}%`,
                'width': `${adjustedWidth}%`,
                'height': `${props.lineHeight}px`,
                'backgroundColor': `${props.bgColor}`,
                'borderRadius': '2px'
              }}
              >
              </div>
            )
          } 
        })}
    </div>
    </div>)
  }